<div class="empty-state-container">
  <i class="bi bi-shield-lock"></i>
  <h5>{{ title }}</h5>
  <p class="mb-0">{{ message }}</p>
</div>
